import clsx from 'clsx'
import styles from './ProgressBar.module.scss'

export interface ProgressBarProps {
  /** 0–100 */
  value: number
  color?: string
  thin?: boolean
  className?: string
  label?: string
}

export function ProgressBar({ value, color, thin, className, label }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value))
  return (
    <div
      className={clsx(styles.progress, thin && styles.progressThin, className)}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div className={styles.progressFill} style={{ width: `${pct}%`, ['--bar-color' as string]: color }} />
    </div>
  )
}

export interface StageSegmentsProps {
  total: number
  done: number
  color?: string
  className?: string
}

/** N segments, first `done` filled — used for stage progress on cards. */
export function StageSegments({ total, done, color, className }: StageSegmentsProps) {
  return (
    <div className={clsx(styles.segments, className)} aria-hidden="true">
      {Array.from({ length: total }).map((_, i) => (
        <span key={i} className={clsx(styles.segment, i < done && styles.segmentDone)} style={{ ['--seg-color' as string]: color }} />
      ))}
    </div>
  )
}
